import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import SVGIcon from "../../../../utils/SVGIcon";
import { validations } from "../../../../config/validations/validations";
import { addSoapReport } from "../../../../store/soapReportSlice";

const AddReport: React.FC<any> = (props) => {
  const { handleAddModal, openAddModal, getList } = props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = (data: { request_id: string }) => {
    setLoading(true);
    const payload = {
      request_id: data.request_id,
    };

    dispatch(addSoapReport(payload))
      .then((res: any) => {
        handleAddModal();
        getList();
      })
      .catch((error: any) => {
        console.log("error", error);

        // handleAddModal();
        // getList();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  return (
    <Modal
      open={openAddModal}
      destroyOnClose
      width={900}
      onCancel={handleAddModal}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      footer={false}
      className="addModal"
      title={`Add Soap Report`}
    >
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
      >
        <Row>
          <Col xs={24} md={12}>
            <InputBox.Text
              label="Request ID"
              name={"request_id"}
              required
              rules={[
                validations.required.text("Request ID"),
                validations.pattern.whitespace,
              ]}
            />
          </Col>
        </Row>
        <Row gutter={[20, 20]} className="mt-20">
          <Col xs={12} md={12} lg={6}>
            <Button type="primary" htmlType="submit" loading={loading}>
              <SVGIcon icon="add" color="#fff" width={55} /> Add Report
            </Button>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                // if (typeAction === "daily") {
                //   form.setFieldsValue({ report_date: dayjs(new Date()) });
                // }
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </Modal>
  );
};

export default AddReport;
